import React from 'react';
import { Icon } from '../../ui/icon';
import { useShellPanelHost } from './panel-host-context';
import { useSidePanelStore } from './side-panel-store';
import './shellPanel.css';

/**
 * Opens and closes the docked assistant, from the page header beside Deploy.
 *
 * Drawn only while the shell hosts a panel and a page has an occupant for it,
 * the same condition under which the shell reserves the column, so the button
 * never offers a panel that cannot appear.
 *
 * One control for both directions, drawn in both states, so the way back to the
 * chat is always in the same place. `aria-pressed` carries the state, and the
 * stylesheet reads it for the pressed-in look, so the two can never disagree.
 *
 * Sparkles, through the app's own `Icon`: it is what this product already means
 * by AI. A speech bubble says chat, which is the mechanism rather than the offer.
 */
export function AskAiButton({ className }: { className?: string }) {
  const panelHosting = useShellPanelHost();
  const { requested, railed, setRailed } = useSidePanelStore();
  if (!panelHosting || !requested) return null;

  const open = !railed;
  return (
    <button
      type="button"
      className={`btn btn-sm ask-ai-btn${className ? ` ${className}` : ''}`}
      onClick={() => setRailed(open)}
      aria-pressed={open}
      title="Ask about this model"
    >
      <Icon icon="far fa-sparkles" />
      Ask AI
    </button>
  );
}
